module.exports = __webpack_public_path__ + "img/1537016727.619943fb.jpg";